export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

/**
 * Encrypts the given plaintext using AES-CBC and returns the IV and ciphertext as a Base64 string.
 * @param {string} plaintext - The text to be encrypted.
 * @returns {Promise<string>} - The Base64-encoded IV and ciphertext.
 */
export const handleEncrypt = async (plaintext) => {
    try {
        // Convert the SECRET_KEY to a CryptoKey
        const keyMaterial = await window.crypto.subtle.importKey(
            'raw',
            new TextEncoder().encode(SECRET_KEY),
            { name: 'AES-CBC' },
            false,
            ['encrypt']
        );

        // Generate a random 16-byte IV (Initialization Vector)
        const iv = window.crypto.getRandomValues(new Uint8Array(16));

        // Encrypt the plaintext
        const encrypted = await window.crypto.subtle.encrypt(
            { name: 'AES-CBC', iv },
            keyMaterial,
            new TextEncoder().encode(plaintext)
        );

        // Combine IV and encrypted data, then Base64-encode
        const combined = btoa(
            JSON.stringify({
                iv: Array.from(iv),
                encrypted: Array.from(new Uint8Array(encrypted)),
            })
        );

        return combined;
    } catch (error) {
        console.error('Encryption failed:', error);
        throw error;
    }
};

